export const getInitialState = () => null;
